import { IAppContext } from "../app-context";
// import { AuthService } from "../../_services/auth.service";
import { AuthService } from "../_services/auth.service";
import { DEFAULT_LANG } from "../constants/languages";

interface ContextSetters {
    setCompanyId: IAppContext["setCompanyId"];
    setIsPhoneVerified: IAppContext["setIsPhoneVerified"];
    setName: IAppContext["setName"];
    setLang: IAppContext["setLang"];
    setCompanyLogo: IAppContext["setCompanyLogo"];
    setUserId: IAppContext["setUserId"];
    setCsDashboardUserRoles?: IAppContext["setCsDashboardUserRoles"];
    setCustomerCompanyId?: IAppContext["setCustomerCompanyId"];
    setCustomerPhone?: IAppContext["setCustomerPhone"];
    setCustomerName?: IAppContext["setCustomerName"];
    phoneNum?: number;
    setShowBankAddPopup?: IAppContext["setShowBankAddPopup"];
    setMandateUserVerificationActionType?: IAppContext["setMandateUserVerificationActionType"];
    setMandateUserVerificationActionTriggered?: IAppContext["setMandateUserVerificationActionTriggered"];
    setMandateUserVerificationCallBackFunction?: IAppContext["setMandateUserVerificationCallBackFunction"];
    setSessionId: IAppContext["setSessionId"] | undefined;
    setThirdPartyCompanyName?: IAppContext["setThirdPartyCompanyName"];
}

export function handleLogout({
    setCompanyId,
    setIsPhoneVerified,
    setName,
    setLang,
    setCompanyLogo,
    setUserId,
    setCsDashboardUserRoles,
    setCustomerCompanyId,
    setCustomerPhone,
    setCustomerName,
    phoneNum,
    setShowBankAddPopup,
    setMandateUserVerificationActionType,
    setMandateUserVerificationActionTriggered,
    setMandateUserVerificationCallBackFunction,
    setSessionId,
    setThirdPartyCompanyName
}: ContextSetters) {
    setUserId?.(undefined);
    setCompanyLogo?.(undefined);
    setCompanyId?.(undefined);
    setIsPhoneVerified?.(false);
    setName?.(undefined);
    setLang?.(DEFAULT_LANG);
    setCsDashboardUserRoles?.(undefined);
    setCustomerCompanyId?.(undefined);
    setCustomerPhone?.(undefined);
    setCustomerName?.(undefined);
    setShowBankAddPopup?.(false);
    setMandateUserVerificationActionType?.("");
    setMandateUserVerificationActionTriggered?.(false);
    setMandateUserVerificationCallBackFunction?.(undefined);
    AuthService.logout(Number(phoneNum));
    setSessionId?.();
    setThirdPartyCompanyName?.("");

    //
    sessionStorage.removeItem("mandatePostingTrucker");
}
